import { SegmentSchema } from '@sondermind/segment';

interface IMobileAppCTAClicked {
  appStore: 'android' | 'iPhone';
}

export enum FlowsIntakeSegmentEvents {
  MOBILE_APP_CTA_CLICKED = 'Mobile App CTA Clicked',
}

export interface IFlowsIntakeSegmentEvents extends SegmentSchema {
  [FlowsIntakeSegmentEvents.MOBILE_APP_CTA_CLICKED]: IMobileAppCTAClicked;
}
